// biome-ignore lint/style/noRestrictedGlobals: encapsulation
export const { trunc } = Math;
